import { SAAE_PRELOADER_Z_INDEX_CLASS } from './saaePreloader';

/**
 * Approximate admin shell metrics for preloader placement (matches AdminLayout header + expanded sidebar).
 */
export const ADMIN_HEADER_TOP_OFFSET_CLASS = 'top-[5.75rem]' as const;

/** Height of the “top half” of the main column below the sticky header (viewport-relative). */
export const ADMIN_MAIN_TOP_HALF_HEIGHT_CLASS = 'h-[calc((100dvh-5.75rem)/2)]' as const;

/**
 * Flex row used for the preloader band: same layout for auth overlay (fixed) and lazy-route overlay
 * (absolute) so the Lottie sits in the same slot under the admin header.
 */
export const ADMIN_PRELOADER_BAND_LAYOUT_CLASS =
  `flex w-full min-h-0 shrink-0 ${ADMIN_MAIN_TOP_HALF_HEIGHT_CLASS} items-center justify-center` as const;

/** Absolute layer at the top of the admin outlet scroll region — matches {@link GlobalPreloader} backoffice band. */
export const ADMIN_OUTLET_PRELOADER_OVERLAY_CLASS =
  `pointer-events-none absolute start-0 end-0 top-0 ${SAAE_PRELOADER_Z_INDEX_CLASS} bg-transparent ${ADMIN_PRELOADER_BAND_LAYOUT_CLASS}` as const;
